import { SoloSetupPage } from '@/components/setup/SoloSetupPage';

export default function SetupPage() {
  return <SoloSetupPage />;
}
